import { Chip } from "@mui/material";
import { useTranslation } from "i18n-fe";

// #3462 -- the "Can't place: N rides not final" indicator for a class that is
// past its last scheduled ride but held open by unfinished rides. Plain chip, no
// link: the row click opens the class drawer, which lists the rides and links to
// each. `count` is the number of unfinished rides the server held the class on
// (#3500): the caller renders the chip only when it has that list, so a chip
// never reads without a reason.
export default function CantPlaceYetChip({ count, sx, ...chipProps }) {
  const { t } = useTranslation("scoreadmin");
  const label = t("ring.cantPlaceYetBadge", { count });
  return <Chip size="small" color="error" variant="outlined" label={label} sx={sx} {...chipProps} />;
}
